import * as marietta from '../../..';
import { CONTROL_ACTIONMODE } from '../../Constants';
import { SVGSprite } from '../../flash/display';
import { Stage } from '../../model';

export default class RoomDraggerMobile {
  dragFunc: Function;

  dragEndFunc: Function;

  viewObj: Element;

  x: number;

  y: number;

  transformMatrix: string;

  public spt: SVGSprite;

  private moveMouseEvent: MouseEvent;

  /**
   * コンストラクタ
   * */
  constructor(targetSprite: SVGSprite) {
    this.viewObj = document.querySelector('#lib_control_room_dragger svg > g').cloneNode(true) as HTMLElement;
    this.viewObj.setAttribute('id', 'control_room_dragger');
    this.spt = new SVGSprite(this.viewObj);
    targetSprite.addChild(this.spt);

    // アクション
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
    } else {
      this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
    }
  }

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseDownMe = (e: MouseEvent & TouchEvent) => {
    // 選択モードのときは、バブリングさせない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
      e.stopPropagation();
    }

    // ドラッグの開始
    e.preventDefault();
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
      document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
    } else {
      document.addEventListener('mousemove', this.onMouseMoveMe);
      document.addEventListener('mouseup', this.onMouseUpMe);
    }

    const scope: RoomDraggerMobile = this;

    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.dragFunc(scope.moveMouseEvent, scope);
      }
    };
  };

  /**
   * マウスが移動した
   */
  onMouseMoveMe = (e: MouseEvent & TouchEvent) => {
    const self: RoomDraggerMobile = this; // 現在の場所

    // pad スマホ用タッチ座標修正
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if (e.touches.length >= 2) {
        // self.deleteMe();
        self.onMouseUpMe(e);
        return;
      }

      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
    }

    self.moveMouseEvent = e;
    // Dragの開始時に測定線を非表示にする
    marietta.webcad.WebCADGlobal.itemManager.hideMeasureLine();
  };

  /**
   * マウスがUPされた
   */
  onMouseUpMe = (e: MouseEvent & TouchEvent) => {
    e.preventDefault();
    this.spt.deleteEnterFrame();
    this.moveMouseEvent = null;

    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.removeEventListener('touchmove', this.onMouseMoveMe);
      document.removeEventListener('touchend', this.onMouseUpMe);
    } else {
      document.removeEventListener('mousemove', this.onMouseMoveMe);
      document.removeEventListener('mouseup', this.onMouseUpMe);
    }

    // 終了の処理
    this.dragEndFunc(e);

    marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id.substring(0, 3) === 'rom' || marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id === 'fit01_01' || marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id === 'fit01_03' || marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id === 'fit02_01') {
      marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
    }
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    // ライン測定を更新する
    marietta.webcad.WebCADGlobal.updateMeasureLine();
  };

  /**
   * 移動 XY
   */
  move(x: number, y: number) {
    this.x = x;
    this.y = y;
    this.updateTranslate();
  }

  /**
   * 移動X
   */
  moveX(x: number) {
    this.x = x;
    this.updateTranslate();
  }

  /**
   * 移動Y
   */
  moveY(y: number) {
    this.y = y;
    this.updateTranslate();
  }

  /**
   * Translateのアップデート
   */
  updateTranslate() {
    // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    let sc: number = 1 / root.scaleX;
    sc *= 3; // 2倍の大きさにする

    // x,yについては、位置補正で使用している固定値6.5/25に対してのみスケールを適用する
    this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x},${this.y})`;
    this.viewObj.setAttribute('transform', this.transformMatrix);
  }

  //--------------------------------
  // モバイル用移動軸対応
  originalPosition: marietta.core.Point;

  /**
   * 元位置の保持
   */
  saveOriginalPoisition() {
    this.originalPosition = new marietta.core.Point(this.x, this.y);
  }

  /**
   * アイコンの非表示
   */
  hide() {
    (<HTMLElement> this.viewObj).style.visibility = 'hidden';
  }

  /**
   * アイコンの表示
   */
  show() {
    (<HTMLElement> this.viewObj).style.visibility = 'visible';
  }
}
